import { createSelector } from 'reselect';

export const getCapeNotifications = createSelector(
  state => state.notification.errors,
  errors => errors,
);
